import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "../lib/scroll";

// A hand-typed "#%E0" would make decodeURIComponent throw and take the page down.
const sectionId = (hash: string) => {
  try {
    return decodeURIComponent(hash.slice(1));
  } catch {
    return hash.slice(1);
  }
};

/**
 * Scrolls to the top on every navigation, or to the section a link names
 * (e.g. /privacy-policy#cookies). `key` also covers a link to the page you are on.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      scrollToSection(sectionId(hash));
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [pathname, hash, key]);

  return null;
};

export default ScrollToTop;
